module.exports = __webpack_public_path__ + "static/lg_bootcamp.800cb8bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lg_bootcamp.png
// module id = 3149
// module chunks = 246501157640856